"use client";

import { useState } from "react";

import clsx from "clsx";

import { useTranslation } from "~/app/hooks/useTranslation";
import cardChart1 from "~/assets/images/chatbotPage/card-chart1.svg?react";
import cardChart2 from "~/assets/images/chatbotPage/card-chart2.svg?react";
import PlayIconSvg from "~/assets/images/chatbotPage/play-icon.svg";
import HeroCarousel from "~/common/components/HeroCarousel";
import useMediaQuery from "~/common/hooks/useMediaQuery";

import styles from "./LiveChatTicketSection2.module.scss";

const AdsCard = ({
  isDark,
  title,
  description,
  graphImage: ImgComp,
  mainValue,
  mainValueType,
  mainValueSmall,
  subtitle,
}) => {
  const isMainValueTypeText = mainValueSmall;

  return (
    <div className={clsx(styles.adsCard, isDark && styles.adsCardDark)}>
      <h3>{title}</h3>
      <p>{description}</p>
      <div className={styles.adsCardGraph} aria-hidden="true">
        <ImgComp />
      </div>
      <div className={styles.adsCardBody}>
        <div className={clsx(styles.adsCardBodyMainValue, isDark && styles.adsCardBodyMainValueDark)}>{mainValue}</div>
        <div
          className={clsx(
            styles.adsCardBodyMainType,
            isMainValueTypeText && styles.adsCardBodyMainTypeText,
            isDark && styles.adsCardBodyMainTypeDark
          )}
        >
          {mainValueType}
        </div>
      </div>
      {subtitle && (
        <div className={clsx(styles.adsCardBodySubtitle, isDark && styles.adsCardBodySubtitleDark)}>
          <PlayIconSvg />
          {subtitle}
        </div>
      )}
    </div>
  );
};

const LiveChatTicketSection2 = ({}) => {
  const { t } = useTranslation();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const isMdUp = useMediaQuery("lg");

  const cardData = [
    {
      isDark: false,
      title: t("seoPages.liveChat.cards.1.title"),
      description: t("seoPages.liveChat.cards.1.description"),
      graphImage: cardChart1,
      mainValue: "1",
      mainValueSmall: true,
      mainValueType: t("seoPages.liveChat.cards.1.valueLabel"),
    },
    {
      isDark: true,
      title: t("seoPages.liveChat.cards.2.title"),
      description: t("seoPages.liveChat.cards.2.description"),
      graphImage: cardChart2,
      mainValue: "AI",
      mainValueType: t("seoPages.liveChat.cards.2.valueLabel"),
      mainValueSmall: true,
    },
    {
      isDark: false,
      title: t("seoPages.liveChat.cards.3.title"),
      description: t("seoPages.liveChat.cards.3.description"),
      graphImage: cardChart1,
      mainValue: "1",
      mainValueSmall: true,
      mainValueType: t("seoPages.liveChat.cards.3.valueLabel"),
    },
  ];

  const cardContents = cardData.map((card, index) => (
    <AdsCard
      key={index}
      isDark={card.isDark}
      title={card.title}
      description={card.description}
      graphImage={card.graphImage}
      mainValue={card.mainValue}
      mainValueType={card.mainValueType}
      subtitle={card.subtitle}
      mainValueSmall={card.mainValueSmall}
    />
  ));

  return (
    <div className={clsx(styles.chatbotSection2, "card")}>
      <div className={styles.chatbotSection2Cards}>
        {isMdUp ? (
          cardContents
        ) : (
          <HeroCarousel selectedIndex={selectedIndex} onSlideChange={setSelectedIndex}>
            {cardContents}
          </HeroCarousel>
        )}
      </div>
    </div>
  );
};

export default LiveChatTicketSection2;
